<template>
  <div>
    <a-form :form="form" layout="vertical">
      <div class="title">{{ $t('admin.content.lab.add.form.title') }}</div>
      <div class="list">
        <a-form-item class="full" :label="$t('admin.content.lab.add.form.fields.major.label')" :colon="false">
          <a-cascader
            allowClear
            :options="schoolList"
            :placeholder="$t('admin.content.lab.add.form.fields.major.placeholder')"
            :fieldNames="{ label: 'name', value: 'id', children: 'child' }"
            v-decorator="[
              'majorId',
              {
                rules: [
                  { required: true, message: $t('admin.content.lab.add.form.fields.major.required') },
                  { validator: checkMajor }
                ]
              }
            ]"
          />
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.content.lab.add.form.fields.name.label')" :colon="false">
          <a-input
            allowClear
            :placeholder="$t('admin.content.lab.add.form.fields.name.placeholder')"
            v-decorator="[
              'name',
              { rules: [{ required: true, message: $t('admin.content.lab.add.form.fields.name.required') }] }
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.content.lab.add.form.fields.type.label')" :colon="false">
          <a-select
            allowClear
            v-decorator="[
              'typeId',
              { rules: [{ required: true, message: $t('admin.content.lab.add.form.fields.type.required') }] }
            ]"
            :placeholder="$t('admin.content.lab.add.form.fields.type.placeholder')"
          >
            <a-select-option v-for="item in labTypeList" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.content.lab.add.form.fields.principal.label')" :colon="false">
          <a-input
            maxLength="10"
            allowClear
            :placeholder="$t('admin.content.lab.add.form.fields.principal.placeholder')"
            v-decorator="[
              'principal',
              { rules: [{ required: true, message: $t('admin.content.lab.add.form.fields.principal.required') }] }
            ]"
          ></a-input>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('admin.content.lab.add.form.fields.phone.label')" :colon="false">
          <a-input
            maxLength="11"
            allowClear
            v-decorator="[
              'principalPhone',
              {
                rules: [
                  { required: !id, message: $t('admin.content.lab.add.form.fields.phone.required') },
                  { pattern: /^1[3456789]\d{9}$/, message: $t('admin.content.lab.add.form.fields.phone.format') }
                ]
              }
            ]"
            :placeholder="$t('admin.content.lab.add.form.fields.phone.placeholder')"
          >
          </a-input>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.content.lab.add.form.fields.hours.label')" :colon="false">
          <a-input
            maxLength="3"
            allowClear
            v-decorator="[
              'classHour',
              {
                rules: [
                  { required: !id, message: $t('admin.content.lab.add.form.fields.hours.required') },
                  { pattern: /^[0-9]+$/, message: $t('admin.content.lab.add.form.fields.hours.format') }
                ]
              }
            ]"
            :placeholder="$t('admin.content.lab.add.form.fields.hours.placeholder')"
          >
          </a-input>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.content.lab.add.form.fields.steps.label')" :colon="false">
          <a-input
            maxLength="3"
            allowClear
            v-decorator="[
              'stepNumber',
              {
                rules: [
                  { required: !id, message: $t('admin.content.lab.add.form.fields.steps.required') },
                  { pattern: /^[0-9]+$/, message: $t('admin.content.lab.add.form.fields.steps.format') }
                ]
              }
            ]"
            :placeholder="$t('admin.content.lab.add.form.fields.steps.placeholder')"
          >
          </a-input>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.content.lab.add.form.fields.suggestTime.label')" :colon="false">
          <a-input
            maxLength="3"
            allowClear
            v-decorator="[
              'suggestTimeRequired',
              {
                rules: [
                  { required: !id, message: $t('admin.content.lab.add.form.fields.suggestTime.required') },
                  { pattern: /^[0-9]+$/, message: $t('admin.content.lab.add.form.fields.suggestTime.format') }
                ]
              }
            ]"
            :placeholder="$t('admin.content.lab.add.form.fields.suggestTime.placeholder')"
          >
          </a-input>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item
          class="full"
          :label="$t('admin.content.lab.add.form.fields.intro.label')"
          :colon="false"
          style="width: 100%"
        >
          <div class="content">
            <a-textarea
              v-decorator="[
                'intro',
                { rules: [{ required: true, message: $t('admin.content.lab.add.form.fields.intro.required') }] }
              ]"
              :auto-size="{ minRows: 3, maxRows: 6 }"
              maxLength="400"
              class="textarea"
            />
            <div class="num">
              <span>{{ form.getFieldValue('intro') ? form.getFieldValue('intro').length : 0 }}</span>
              <span>/400</span>
            </div>
          </div>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('admin.content.lab.add.form.fields.url.label')" :colon="false">
          <a-input
            allowClear
            v-decorator="[
              'url',
              {
                rules: [
                  { required: !id, message: $t('admin.content.lab.add.form.fields.url.required') },
                  { type: 'url', message: $t('admin.content.lab.add.form.fields.url.format') }
                ]
              }
            ]"
            :placeholder="$t('admin.content.lab.add.form.fields.url.placeholder')"
          >
          </a-input>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.content.lab.add.form.fields.video.label')" :colon="false">
          <Upload
            @uploadData="e => uploadData(e, 'introVideoUrl')"
            :fileUrl="form.getFieldValue('introVideoUrl')"
            :desc="$t('admin.content.lab.add.form.fields.video.desc')"
            :accept="['mp4']"
            coverType="video"
            v-decorator="[
              'introVideoUrl',
              { rules: [{ required: true, message: $t('admin.content.lab.add.form.fields.video.required') }] }
            ]"
          ></Upload>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.content.lab.add.form.fields.guidedVideo.label')" :colon="false">
          <Upload
            @uploadData="e => uploadData(e, 'guidedVideoUrl')"
            :fileUrl="form.getFieldValue('guidedVideoUrl')"
            :desc="$t('admin.content.lab.add.form.fields.guidedVideo.desc')"
            :accept="['mp4']"
            coverType="video"
            v-decorator="[
              'guidedVideoUrl',
              { rules: [{ required: true, message: $t('admin.content.lab.add.form.fields.guidedVideo.required') }] }
            ]"
          ></Upload>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.content.lab.add.form.fields.cover.label')" :colon="false">
          <Upload
            @uploadData="e => uploadData(e, 'cover')"
            :fileUrl="form.getFieldValue('cover')"
            :desc="$t('admin.content.lab.add.form.fields.cover.desc')"
            :accept="['jpg', 'png']"
            v-decorator="[
              'cover',
              { rules: [{ required: true, message: $t('admin.content.lab.add.form.fields.cover.required') }] }
            ]"
          ></Upload>
        </a-form-item>
      </div>
      <div class="title">{{ $t('admin.content.lab.add.form.other.title') }}</div>
      <div class="list">
        <a-form-item
          class="full"
          :label="$t('admin.content.lab.add.form.fields.status.label')"
          :colon="false"
          style="width: 25%"
        >
          <a-select
            allowClear
            v-decorator="[
              'status',
              { rules: [{ required: true, message: $t('admin.content.lab.add.form.fields.status.required') }] }
            ]"
            :placeholder="$t('admin.content.lab.add.form.fields.status.placeholder')"
          >
            <a-select-option v-for="item in stateList" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          class="full recommend"
          :label="$t('admin.content.lab.add.form.fields.examine.label')"
          :colon="false"
          style="width: 25%; position: relative"
        >
          <a-radio-group
            v-decorator="[
              'is_examine',
              { rules: [{ required: true, message: $t('admin.content.lab.add.form.fields.examine.required') }] }
            ]"
            class="radioGroup"
            size="small"
            style="margin-left: 5px;"
          >
            <a-radio :value="1">{{ $t('admin.content.lab.add.form.fields.examine.options.support') }}</a-radio>
            <a-radio :value="2">{{ $t('admin.content.lab.add.form.fields.examine.options.notSupport') }}</a-radio>
          </a-radio-group>
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>{{ $t('admin.content.lab.add.form.fields.examine.tooltip') }}</span>
            </template>
            <div class="check-tooltip">?</div>
          </a-tooltip>
        </a-form-item>
        <a-form-item
          class="full recommend"
          :label="$t('admin.content.lab.add.form.fields.recommend.label')"
          :colon="false"
          style="width: 25%"
        >
          <div v-decorator="['recommend']"></div>
          <div style="display: flex; align-items: center; width: 40vw">
            <a-radio-group class="radioGroup" v-model="recommend" @change="changeRecommend" size="small">
              <a-radio :value="false">{{ $t('admin.content.lab.add.form.fields.recommend.options.no') }}</a-radio>
              <a-radio :value="true">{{ $t('admin.content.lab.add.form.fields.recommend.options.yes') }}</a-radio>
            </a-radio-group>
            <a-select
              :placeholder="$t('admin.content.lab.add.form.fields.recommend.levelPlaceholder')"
              v-if="recommend"
              v-model="recommendLevelSelect"
            >
              <a-select-option v-for="item in recommendLevel" :key="item.id" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('admin.content.lab.add.form.fields.likes.label')">
          <a-input
            maxLength="5"
            allowClear
            v-decorator="[
              'likeNumber',
              { rule: [{ pattern: /^[0-9]+$/, message: $t('admin.content.lab.add.form.fields.likes.format') }] }
            ]"
            :placeholder="$t('admin.content.lab.add.form.fields.likes.placeholder')"
          >
          </a-input>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.content.lab.add.form.fields.collects.label')">
          <a-input
            maxLength="5"
            allowClear
            v-decorator="[
              'collectNumber',
              { rule: [{ pattern: /^[0-9]+$/, message: $t('admin.content.lab.add.form.fields.collects.format') }] }
            ]"
            :placeholder="$t('admin.content.lab.add.form.fields.collects.placeholder')"
          >
          </a-input>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.content.lab.add.form.fields.views.label')">
          <a-input
            maxLength="5"
            v-decorator="[
              'baseViewNumber',
              { rule: [{ pattern: /^[0-9]+$/, message: $t('admin.content.lab.add.form.fields.views.format') }] }
            ]"
            :placeholder="$t('admin.content.lab.add.form.fields.views.placeholder')"
          >
          </a-input>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.content.lab.add.form.fields.completions.label')">
          <a-input
            maxLength="5"
            allowClear
            v-decorator="[
              'baseFinishNumber',
              { rule: [{ pattern: /^[0-9]+$/, message: $t('admin.content.lab.add.form.fields.completions.format') }] }
            ]"
            :placeholder="$t('admin.content.lab.add.form.fields.completions.placeholder')"
          >
          </a-input>
        </a-form-item>
      </div>
      <div class="title">{{ $t('admin.content.lab.add.dataInterface.title') }}</div>
      <div class="list">
        <a-form-item class="full" :label="$t('admin.content.lab.add.dataInterface.fields.platform.label')">
          <a-select allowClear v-decorator="['dataPushType']" :placeholder="$t('admin.content.lab.add.dataInterface.fields.platform.placeholder')">
            <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item class="full" label="APP ID" v-if="form.getFieldValue('dataPushType') === '1' && id">
          <a-input v-decorator="['appId']" disabled :placeholder="$t('admin.content.lab.add.dataInterface.fields.appId.placeholder')"> </a-input>
        </a-form-item>
        <a-form-item class="full" label="Secret Key" v-if="form.getFieldValue('dataPushType') === '1' && id">
          <a-input
            :type="!passwordFlag ? 'password' : 'text'"
            disabled
            v-decorator="['secretKey']"
            :placeholder="$t('admin.content.lab.add.dataInterface.fields.secretKey.placeholder')"
          >
            <img
              @click="passwordFlag = true"
              v-if="!passwordFlag"
              src="@/assets/icons/icon_bi.png"
              slot="suffix"
              alt=""
            />
            <img @click="passwordFlag = false" v-else src="@/assets/icons/icon_kai.png" slot="suffix" alt="" />
          </a-input>
        </a-form-item>
        <a-form-item class="full" label="accessKey" v-if="form.getFieldValue('dataPushType') === '2'">
          <a-input
            v-decorator="['accessKey', { rules: [{ required: true, message: $t('admin.content.lab.add.dataInterface.fields.accessKey.required') }] }]"
            :placeholder="$t('admin.content.lab.add.dataInterface.fields.accessKey.placeholder')"
          >
          </a-input>
        </a-form-item>
        <a-form-item class="full" label="partnerId" v-if="form.getFieldValue('dataPushType') === '2'">
          <a-input
            v-decorator="['partnerId', { rules: [{ required: true, message: $t('admin.content.lab.add.dataInterface.fields.partnerId.required') }] }]"
            :placeholder="$t('admin.content.lab.add.dataInterface.fields.partnerId.placeholder')"
          >
          </a-input>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.content.lab.add.dataInterface.fields.loginKey.label')" v-if="form.getFieldValue('dataPushType') === '2'">
          <a-input
            v-decorator="['privateKey', { rules: [{ required: true, message: $t('admin.content.lab.add.dataInterface.fields.loginKey.required') }] }]"
            :placeholder="$t('admin.content.lab.add.dataInterface.fields.loginKey.placeholder')"
          >
          </a-input>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" label="resourceCode" v-if="form.getFieldValue('dataPushType') === '2'">
          <a-input
            v-decorator="['resourceCode', { rules: [{ required: true, message: $t('admin.content.lab.add.dataInterface.fields.resourceCode.required') }] }]"
            :placeholder="$t('admin.content.lab.add.dataInterface.fields.resourceCode.placeholder')"
          >
          </a-input>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.content.lab.add.dataInterface.fields.experimentGoals.label')" v-if="form.getFieldValue('dataPushType') === '2'">
          <a-textarea
            :auto-size="{ minRows: 3 }"
            v-decorator="['experimentGoals', { rules: [{ required: true, message: $t('admin.content.lab.add.form.dataInterface.fields.experimentGoals.required') }] }]"
            :placeholder="$t('admin.content.lab.add.dataInterface.fields.experimentGoals.placeholder')"
          >
          </a-textarea>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.content.lab.add.dataInterface.fields.experimentContent.label')" v-if="form.getFieldValue('dataPushType') === '2'">
          <a-textarea
            :auto-size="{ minRows: 3 }"
            v-decorator="['experimentContent', { rules: [{ required: true, message: $t('admin.content.lab.add.dataInterface.fields.experimentContent.required') }] }]"
            :placeholder="$t('admin.content.lab.add.dataInterface.fields.experimentContent.placeholder')"
          >
          </a-textarea>
        </a-form-item>
      </div>
    </a-form>
    <div class="tip" v-if="tipShow">
      <div>
        <img :src="tip[tipIndex].img" alt="" />
        <span class="title">{{ tip[tipIndex].title }}</span>
        <p class="desc">
          <span v-for="item of tip[tipIndex].desc" :key="item">{{ item }}</span>
        </p>
        <div class="operation">
          <a-button @click="cancleCreat">{{ $t('admin.content.lab.add.form.tip.cancel') }}</a-button>
          <a-button type="primary" @click="creat(tip[tipIndex].url)">{{
            $t('admin.content.lab.add.form.tip.create')
          }}</a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Upload from '@/components/upload/index.vue'

import { collegeList, labTypeMap } from '@/api/admin'

export default {
  props: {
    majorId: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  },
  components: {
    Upload
  },
  data() {
    return {
      id: undefined,
      stateList: [
        { id: 1, name: '启用' },
        { id: 2, name: '禁用' }
      ],
      platformList: [
        { id: '1', name: '此平台' },
        { id: '2', name: '虚拟仿真实训中心' }
      ],
      passwordFlag: true,
      labTypeList: [],
      schoolList: [],
      replaceFields: {
        key: 'id',
        value: 'id',
        title: 'name',
        children: 'child'
      },
      recommend: false,
      recommendLevelSelect: 0,
      recommendLevel: [
        {
          id: 1,
          name: '一级'
        },
        {
          id: 2,
          name: '二级'
        },
        {
          id: 3,
          name: '三级'
        },
        {
          id: 4,
          name: '四级'
        },
        {
          id: 5,
          name: '五级'
        },
        {
          id: 6,
          name: '六级'
        },
        {
          id: 7,
          name: '七级'
        },
        {
          id: 8,
          name: '八级'
        },
        {
          id: 9,
          name: '九级'
        },
        {
          id: 10,
          name: '十级'
        }
      ],
      collegeId: undefined,
      departmentId: undefined,
      form: this.$form.createForm(this),
      tip: [
        {
          title: this.$t('admin.content.lab.add.tips.dictionaries.title'),
          desc: this.$t('admin.content.lab.add.tips.dictionaries.desc'),
          img: require('@/assets/img/school.png'),
          url: '/system/school'
        },
        {
          title: this.$t('admin.content.lab.add.tips.type.title'),
          desc: this.$t('admin.content.lab.add.tips.type.desc'),
          img: require('@/assets/img/lab.png'),
          url: '/system/type'
        }
      ],
      tipShow: false,
      tipIndex: 0,
      majorIdMap: [],
      popconfirmText:
        '使用考核功能，需要对接平台接口，请确认该实验是否已经和平台的接口进行对接，如未对接，即使使用该功能，也无法对数据进行统计。'
    }
  },
  watch: {
    majorId: {
      handler(val) {
        this.form.setFieldsValue({
          majorId: this.majorIdMap[val]
        })
      }
    }
  },
  methods: {
    // 判断选中项是否是第三级
    isThirdLevel(id) {
      console.log(id)
      let foundLevel = null // 用于存储找到的级别
      let foundGather = []

      const find = (data, level, gather) => {
        data.forEach(item => {
          const gatherCopy = [...gather]
          gatherCopy.push(item.id)
          if (item.id == id) {
            foundGather = [...gatherCopy]
            foundLevel = level // 找到了目标项，赋值给foundLevel
          } else {
            level++
            find(item.child, level, gatherCopy) // 继续递归查找
          }
        })
      }

      find(this.schoolList, 1, []) // 调用内部查找函数

      return { foundLevel, foundGather }
    },
    uploadData(data, type) {
      this.form.setFieldsValue({
        [type]: data.length > 0 ? data[0].url : ''
      })
    },
    changeRecommend(e) {
      this.recommendLevelSelect = this.recommend ? 1 : 0
    },
    async getCollegeList() {
      const res = await collegeList()
      if (res.code === 200) {
        this.schoolList = res.data.list
        if (this.schoolList.length === 0) {
          this.tipIndex = 0
          this.tipShow = true
        }
        this.schoolList.forEach(a => {
          this.majorIdMap[a.id] = [a.id]
          if (!a.child.length) {
            delete a.child
            return
          }
          a.child.forEach(b => {
            this.majorIdMap[b.id] = [a.id, b.id]
            if (!b.child.length) {
              delete b.child
              return
            }
            b.child.forEach(c => {
              this.majorIdMap[c.id] = [a.id, b.id, c.id]
              if (!c.child.length) {
                delete c.child
              }
            })
          })
        })
      }
    },
    async getLabType() {
      const res = await labTypeMap()
      if (res.code === 200) {
        this.labTypeList = res.data.list
        if (this.labTypeList.length === 0) {
          this.tipIndex = 1
          this.tipShow = true
        }
      }
    },
    handleSubmit() {
      let isSuccess = false
      const majorId = this.form.getFieldValue('majorId')

      this.form.setFieldsValue({
        recommend: this.recommend ? this.recommendLevelSelect : 0
      })
      if (Array.isArray(majorId) && majorId.length === 3) {
        this.collegeId = majorId[0] // 注册失效，后续更改
        this.departmentId = majorId[1]
        this.majorId = majorId[2]
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          isSuccess = true
        }
      })
      return isSuccess
    },
    cancleCreat() {
      this.tipShow = false
      this.$router.back()
    },
    async creat(url) {
      await this.$router.push({
        path: url
      })
      window.location.reload()
    },
    checkMajor(rule, value, callback) {
      if (Array.isArray(value) && value.length > 0 && value.length < 3) {
        callback(new Error('请选择到专业'))
      }
      callback()
    }
  },
  mounted() {
    this.getCollegeList()
    this.getLabType()
  }
}
</script>

<style lang="less" scoped>
.tip {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  > div {
    width: 333px;
    background-image: url('~@/assets/img/background.png');
    background-color: #fff;
    border-radius: 12px;
    padding-bottom: 22px;
    img {
      width: 63px;
      margin: 0 auto;
      margin-top: -31px;
      display: block;
    }
    .title {
      width: 100%;
      text-align: center;
      font-weight: 500;
      font-size: 16px;
      color: #000000;
      margin-top: 9px;
      display: block;
      font-weight: bold;
    }
    p {
      margin-top: 9px;
      width: 100%;
      text-align: center;
      span {
        font-size: 14px;
        color: #596777;
        display: block;
      }
    }
    .operation {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 68px;
      margin-top: 22px;
      .ant-btn,
      .ant-btn:hover {
        border: 0;
        min-width: 94px;
        height: 35px;
        color: #9b1205;
        border-radius: 6px;
        background: #fcf3ec;
        box-shadow: 0px 0px 3px 0px rgba(204, 76, 26, 0.12);
      }
      .ant-btn.ant-btn-primary,
      .ant-btn.ant-btn-primary:hover {
        border: 0;
        width: auto;
        height: 35px;
        color: #fff;
        margin-left: 24px;
        background: linear-gradient(248deg, #ff6d00 0%, #f5a623 100%);
        box-shadow: 0px 0px 3px 0px rgba(204, 76, 26, 0.12);
        border-radius: 6px;
      }
    }
  }
}
h4 {
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
}
.admin {
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;
  .user-logo {
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }
  .down {
    width: 10px;
    margin-left: 5px;
  }
}
/deep/.ant-input-suffix {
  right: 12px;
  img {
    width: 23px;
    cursor: pointer;
  }
}
/deep/.ant-form {
  .title {
    display: flex;
    font-size: 14px;
    font-weight: 600;
    color: #627587;
    line-height: 20px;
    position: relative;
    padding: 12px 17px;
    margin-bottom: 30px;
    align-items: center;
    border-bottom: 1px solid #ededed;
    &::before {
      left: 0;
      content: '';
      width: 4px;
      height: 12px;
      border-radius: 2px;
      position: absolute;
      background: #6b738c;
    }
  }
  .list {
    display: flex;
    > div {
      width: 25%;
    }
    .coverImg {
      background: #413e3e;
    }
    .ant-form-item-label {
      // position: absolute;
      // top: 0;
      // left: 0;
      // width: 100px;
      .ant-form-item-no-colon::after {
        content: ':';
      }
      // text-align: right;
    }
    .ant-form-item-label label {
      color: #000000;
    }
    .ant-form-item {
      // width: 50%;
      // padding-left: 105px;
      position: relative;
      padding-right: 45px;
    }
    .ant-input-affix-wrapper .ant-input-suffix {
      position: absolute;
      img {
        width: 23px;
        height: 23px;
      }
    }
    .ant-calendar-picker div {
      position: relative;
      .ant-calendar-picker-input {
        width: 228px;
        height: 35px;
        margin-right: 0;
        color: #000000;
        border-radius: 4px;
        background: #ffffff;
        border: 1px solid #d8dce0;
      }
    }
    .ant-input,
    .ant-select {
      border-radius: 4px;
      color: #000000;
    }
    .full .ant-input,
    .full .ant-select {
      width: 100%;
      height: 35px;
      color: #000000;
      margin-right: 0;
      border-radius: 4px;
    }
    .recommend {
      // display: flex;
      .ant-radio-group {
        display: flex;
        align-items: center;
        .ant-radio-wrapper {
          min-width: 86px;
          padding-left: 5px;
          margin-right: 10px;
          .ant-radio {
            color: #000000;
          }
        }
      }
      .ant-select {
        width: 107px;
        margin-left: 0px;
        border-radius: 4px;
        color: #000000;
        height: 35px;
      }
      .ant-radio-wrapper {
        margin-bottom: 0px !important;
      }
    }
    .content {
      position: relative;
      .textarea {
        background: #fcfcfc;
        border-radius: 4px;
        border: 1px solid #d8dce0;
      }
      .num {
        position: absolute;
        right: 10px;
        bottom: 10px;
        font-size: 12px;
        color: #5e7a92;
      }
    }
    .ant-input-wrapper.ant-input-group {
      .ant-input {
        border-right: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      .ant-input-group-addon {
        background: #fff;
        font-size: 14px;
        font-weight: 400;
        color: #5e7a92;
        line-height: 20px;
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
      }
    }
    .has-feedback {
      .ant-cascader-picker-arrow {
        margin-right: 0;
      }
      .ant-cascader-picker-clear {
        right: 12px;
      }
    }
    .check-tooltip {
      position: absolute;
      left: 46px;
      top: -34px;
      background: #eee;
      width: 18px;
      height: 18px;
      line-height: 18px;
      text-align: center;
      font-size: 12px;
      border-radius: 50%;
      cursor: pointer;
    }
  }
}
</style>
